// removed by extract-text-webpack-plugin
module.exports = {"album":"_3cvPJ9XWbb7Q0jbuy3GIQr","mainInfo":"_1-vZ4kak0PCSMAPljkp2Hm","watermark":"_239qezIR26AxLfh2V27v33"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Playlist/PlaylistAlbum/PlaylistAlbum.scss
// module id = 1289
// module chunks = 1